import alt from '../alt';
export default alt.createActions({
  init: (snapshot) => snapshot,
  toggleMenu: () => true,
});
